import { render } from "./OrderFormPage.vue?vue&type=template&id=4e5a1366&ts=true"
import script from "./OrderFormPage.vue?vue&type=script&lang=ts"
export * from "./OrderFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__